// extracted by mini-css-extract-plugin
export var borderRadius = "_fp-4";
export var large = "_fp-3";
export var logoContainer = "_fp-0";
export var nameLogo = "_fp-2";
export var small = "_fp-1";